import {
  BrowserRouter as Router,
  RouterProvider,
} from "react-router-dom";
import router from "./Routes/Route";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

import { LocalizationProvider } from "@mui/x-date-pickers";
import React from "react";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { createEmsTheme } from "./theme/emsMuiTheme";
import DisableBrowserAutofill from "./Components/DisableBrowserAutofill";

function App() {
  const theme = React.useMemo(() => createEmsTheme("light"), []);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <DisableBrowserAutofill />
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <RouterProvider router={router} />
      </LocalizationProvider>
    </ThemeProvider>
  );
}
export default App;
